import React from 'react';
import Switch from 'react-switch';

type CustomSwitchProps = {
  value?: any;
  onChange?: any;
  disabled?: boolean;
};

export default function CustomSwitch({ value, onChange, disabled }: CustomSwitchProps) {
  const onColor = getComputedStyle(document.documentElement).getPropertyValue('--saral-purple').trim();
  const offColor = getComputedStyle(document.documentElement).getPropertyValue('--light-grey').trim();
  return (
    <>
      <Switch
        disabled={disabled}
        checked={value}
        onChange={onChange}
        draggable={false}
        checkedIcon={false}
        uncheckedIcon={false}
        height={16}
        width={32}
        offColor={offColor}
        onColor={onColor}
        handleDiameter={12}
      />
    </>
  );
}
